export type Vertical = 'knowledge' | 'housing' | 'services' | 'opportunity' | 'events'

export type AccessModel = 'free' | 'rental' | 'purchase'

export interface ResourceLicence {
  model: AccessModel
  priceNaira: number
  rentalDays?: number
  preview: boolean
  download: boolean
  print: boolean
  redistribute: false
  territories: string
}

export interface KnowledgeResource {
  id: string
  title: string
  author: string
  publisher?: string
  kind:
    | 'Textbook'
    | 'Lecture notes'
    | 'Past questions'
    | 'Research paper'
    | 'Video course'
    | 'Course pack'
    | 'Thesis'
  edition: string
  field: string
  pagesOrLength: string
  rating: number
  reviewCount: number
  licences: ResourceLicence[]
  authorVerified: boolean
}

export interface Entitlement {
  resourceId: string
  model: AccessModel
  grantedOn: string
  expiresOn?: string
  state: 'active' | 'expired'
}

export interface ServiceCategory {
  id: string
  category: string
  subcategories: string[]
  configurable: true
}

export interface ServicePackage {
  id: string
  name: string
  priceNaira: number
  deliveryDays?: number
  sessionMinutes?: number
  includes: string[]
}

export interface ServiceProvider {
  id: string
  handle: string
  displayName: string
  initials: string
  headline: string
  category: string
  subcategory: string
  skills: string[]
  mentorship: boolean
  responseTime: string
  completedOrders: number
  rating: number
  reviewCount: number
  identityVerified: boolean
  packages: ServicePackage[]
  availabilityLabel: string
}

export type OrderState =
  | 'REQUESTED'
  | 'ACCEPTED'
  | 'FUNDED'
  | 'IN_ESCROW'
  | 'IN_PROGRESS'
  | 'DELIVERED'
  | 'BUYER_REVIEW'
  | 'COMPLETED'
  | 'RELEASED'
  | 'CANCELLED'
  | 'DISPUTED'
  | 'REFUNDED'
  | 'PARTIALLY_REFUNDED'
  | 'EXPIRED'

export interface MarketplaceOrder {
  id: string
  reference: string
  vertical: Vertical
  title: string
  counterparty: string
  counterpartyHandle: string
  amountNaira: number
  feeNaira: number
  state: OrderState
  placed: string
  dueLabel: string
  history: { state: OrderState; at: string }[]
}

export const ORDER_FLOW: OrderState[] = [
  'REQUESTED',
  'ACCEPTED',
  'FUNDED',
  'IN_ESCROW',
  'IN_PROGRESS',
  'DELIVERED',
  'BUYER_REVIEW',
  'COMPLETED',
  'RELEASED',
]

export const ORDER_ALTERNATIVES: OrderState[] = [
  'CANCELLED',
  'DISPUTED',
  'REFUNDED',
  'PARTIALLY_REFUNDED',
  'EXPIRED',
]

export function orderStateLabel(state: OrderState): string {
  return state
    .toLowerCase()
    .split('_')
    .join(' ')
    .replace(/^./, (character) => character.toUpperCase())
}
